// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"37d2e832","253":"789f6848","591":"1df40eea","850":"2a924c21"}[chunkId] + ".css";
};